import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from '../../app/models/CATCursos';
import { Botonera } from '../Portafolio/helpers/botonera';
import { useStore } from "../../app/stores/store";
import { AnchorTabsPosgrados } from "../Portafolio/Handlers/AnchorTabs";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";
import banner from "../../images/maestrias_doctorados.png";
import curPost from "../Portafolio/src/imgs/page_headers/posgrados.png";
import Footer from "../Footer";
import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import icon_location from '../Portafolio/src/imgs/pinpoint_icon.svg';
import { RegionalBannerCentral } from '../Portafolio/Handlers/RegionalBannerCentral';
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";
import { FiltroCardsPos } from "../Portafolio/Handlers/FiltroCursos";
import { nombreDelegacion } from '../Portafolio/helpers/nombreDelegacion';
import { Container } from "semantic-ui-react";
import { myBreadCrumbs2L } from '../Portafolio/Handlers/Breadcrumbs';

export default observer(function Cursos() {

  const { userStore: { user, logout, isLoggedIn } } = useStore();
  const { CATCursosStore } = useStore();
  const { loadCATCursosByDir, CATCursosRegistry, getCATCursosByCodigo, loadCATCursosByLevel } = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByLevel("17", "1");
      loadCATCursosByLevel("18", "1");
    }
  }, [CATCursosRegistry.size, loadCATCursosByLevel]);

  if (CATCursosStore.loadingInitial)

    return <LoadingComponent content="Cargando datos.." />;
  return (
    <>

      {/* <RegionalBannerCentral /> */}

      <div className="regional-title">
        <div className="regional-block-title"></div>
        <h3>INAP - Postgrados</h3>
      </div>
      <div className="regional-head-area container-fluid"></div>
      <style>{`
        .regional-head-area {
          background-image: url(${curPost});
          background-size: cover;
          background-position: center top;
          background-repeat: no-repeat;
          width: 100%;
          position: relative;
          background-color: #f5f5f5;
        }

       
        @media (max-width: 549px) {
          .regional-head-area {
            height: 90px;
            background-size: contain;
          }
          .regional-title h3 {
            font-size: 16px;
          }
        }

        @media (min-width: 550px) and (max-width: 767px) {
          .regional-head-area {
            height: 130px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 18px;
          }
        }

        @media (min-width: 768px) and (max-width: 991px) {
          .regional-head-area {
            height: 170px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 20px;
          }
        }

        @media (min-width: 992px) and (max-width: 1199px) {
          .regional-head-area {
            height: 215px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 22px;
          }
        }

        @media (min-width: 1200px) and (max-width: 1990px) {
          .regional-head-area {
            height: 250px;
             background-size: contain;
          }
          .regional-title h3 {
            font-size: 24px;
          }
        }

        @media (min-width: 1491px) {
          .regional-head-area {
            height: 260px;
            width: 100%;
          }
          .regional-title h3 {
            font-size: 26px;
          }
        }
      `}</style>

      < AnchorTabsPosgrados />
      <AnchorTabsCategories />

      <div className="portafolio_phome_area catalogo_servicios">

        <div className="portafolio_header">
        {myBreadCrumbs2L("Posgrados")}
        <Botonera/>
        <FiltroCardsPos/>
          <div className="buscador_area">
            <BuscadorComponent />
            
          </div>
        </div>

        <div id="hw_search" className="portafolio_htexto">
          <p>En alianza y coordinación con el ICAP, INAP ofrece educación científica y académica de alto nivel a profesionales del sector público y privado que están involucrados en la toma de decisiones dentro de la Administración Pública. Sus programas están orientados a proporcionar herramientas para que el funcionario público pueda incidir en la reforma del Estado y en la transformación y modernización de la Administración Pública. </p>
        </div>

        <div id="section1" className="portafolio_subcat first_section">
          <h2>Maestrías</h2>
        </div>

        <Container className="portafolio_subcat_desc">
          <p>El INAP contribuirá al fortalecimiento de la gestión de las entidades públicas a través de la formación gerencial con orientación estratégica, de servidores y funcionarios públicos, a través de la participación en programas de estudios de postgrado de maestría y doctorado, incrementando la capacidad, eficacia y eficiencia del sector público, desarrollando la capacidad de orientar y dirigir estratégicamente a las instituciones generando valor público, contribuyendo a la reforma del Estado, la transformación y modernización de la administración pública guatemalteca.</p>
          <p>Las maestrías están orientadas a investigar y proponer soluciones, por medio del abordaje de problemas o temas críticos de la gestión y administración pública, desde un enfoque de gestión estratégica efectiva para que las diferentes instituciones alcancen resultados y generen valor público contribuyendo a mejorar la calidad de vida de la población.</p>
        </Container> 
        <div id="hw_search" className="portafolio_content">
          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {
            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions?.fechaDeInicioInscripcion );
            if (
              item.nivel == "17" && item.editions?.is_active === true ||
              item.nivel == "177" && item.editions?.is_active === true ||
              item.nivel == "1777" && item.editions?.is_active === true
            ) {
              return (               
                  
                  <div className="portafolio_card" id={item.nivel} key={item.id}>

                    <Link to={url} >

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes corto_para_fecha">
                            <img src={icon_person} />
                            <p>{item.editions?.cupoActual} Inscritos</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> Consultar Fecha </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_location} />
                          <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                        </div>
                      </div>
                      <div className="pcard_linea"><span></span></div>
                    </Link>
                  </div>                                  
              );
            }
          })}

        </div>
        <div id="section2" className="portafolio_subcat second_section">
          <h2></h2>
        </div>
        <div id="hw_search" className="portafolio_content">
          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {
            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions?.fechaDeInicioInscripcion );
            if (
              item.nivel == "18" && item.editions?.is_active === true ||
              item.nivel == "188" && item.editions?.is_active === true ||
              item.nivel == "1888" && item.editions?.is_active === true
            ) {
              return (      
                 <div className="portafolio_card" id={item.nivel} key={item.id}>
                    <Link to={url}>
                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_intermedia">{item.modalidad}</p></div>
                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions?.numeroEdicion}</p>
                        </div>
                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>
                        <div className="card_info_curso">
                          <div className="pcard_estudiantes corto_para_fecha">
                            <img src={icon_person} />
                            <p>{item.editions?.cupoActual} Inscritos</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> Consultar Fecha </p>
                          </div>
                        </div>
                        <div className="pcard_docentes">
                          <img src={icon_location} />
                          <p>Sede: {nombreDelegacion(item?.nivel)}</p>
                        </div>
                      </div>
                      <div className="pcard_linea"><span></span></div>
                    </Link>
                  </div>
                          );
            }
          })}
        </div>
      </div>
      <Footer />
    </>
  );
});
